import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {ReplaySubject, Subject, Subscription, takeUntil} from 'rxjs';
import {AllService} from '../../services/all.service';
import {environment} from 'src/environments/environment';
import {AllMessengersService} from '../../pages/page-start/all-messengers.service';
import {NotifierWrapService} from '../../services/notifier-wrap.service';
import {IMessengerConnector} from '../../types/all.type';
import {InterfaceService} from '../../services/interface.service';
import {SenderService} from '../../services/sender.service';
import {log} from '../../functions';
import { debounceTime, filter, first } from 'rxjs/operators';
import {DcService} from '../../services/dc.service';
import { FixTypePipe } from "../../pipes/fixtype.pipe";


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject();
  @Input() page = 'chats';
  _showSelect = false;
  environment = environment;
  arServices: IMessengerConnector[] = [];
  detectChanges$: ReplaySubject<void> = new ReplaySubject();
  generateList$: ReplaySubject<void> = new ReplaySubject();

  constructor(
    public fixTypePipe: FixTypePipe,
    public renderer: Renderer2,
    private dcService: DcService,
    public senderService: SenderService,
    public interfaceService: InterfaceService,
    public notifierWrapService: NotifierWrapService,
    public allMessengersService: AllMessengersService,
    public allService: AllService,
    private cd: ChangeDetectorRef,
    public router: Router
  ) {
    this.cd.detach();
  }

  generateList(): void {
    this.arServices = [];
    const addSubmenu = (service: IMessengerConnector, Service: IMessengerConnector) => {
      if (service) {
        if (!service.nemuAccounts.find((v) => v.type === Service.type)) {
          if (Service.isAuth) {
            service.nemuAccounts.push(Service);
          }
        }
      }
    };
    for (const Service of this.allMessengersService.arServicesAuthorized) {
      // const type = this.fixTypePipe.transform(Service.type);
      const rootService = this.arServices.find(
        (v) => v.name === Service.name
      );

      if (!rootService) {
        this.arServices.push(Service);
        addSubmenu(this.arServices[0], Service);
      }else{
        addSubmenu(rootService, Service);
      }

    }
    this.detectChanges$.next();
  }

  ngOnInit(): void {

    this.allMessengersService.getProfile$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.generateList$.next();
      this.detectChanges$.next();
    });
    this.allService.login$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.generateList$.next();
      this.detectChanges$.next();
      //  TODO перенести
      if (this.interfaceService.isLeadsDomain) {
        this.goToLeads();
      }
    });
    this.allService.logout$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.generateList$.next();
      this.detectChanges$.next();
    });
    this.dcService.detectChanges$.pipe(filter(v => v === 'navbar')).subscribe((component) => {
      this.detectChanges$.next();
      this.generateList$.next();
    });
    this.allService.setService$.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe((type) => {
      this.detectChanges$.next();
    });
    this.interfaceService.logout$.pipe(takeUntil(this.destroy$), debounceTime(1000)).subscribe(() => {
      this.generateList$.next();
    });

    this.generateList();
    /*if (this.isDebug) {
      setInterval(() => {
        this.detectChanges$.next();
      }, 1000);
    }*/

    this.detectChanges$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe(() => {
      this.cd.detectChanges();
    });
    this.generateList$.pipe(debounceTime(1000), takeUntil(this.destroy$)).subscribe(() => {
      this.generateList();
    });
  }

  set showSelect(val) {
    this.notifierWrapService.playAudio('hover');
    this._showSelect = val;
    this.detectChanges$.next();
  }

  setService(type): void {
    this.notifierWrapService.playAudio('hover');
    log('NavbarComponent.setService', type);
    if (type !== 'all') {
      this.allMessengersService.setServiceActive(type, false);
    } else {
    }
    this.allService.setService$.next(type);
    this.showSelect = false;
    this.router.navigate(['/ui']);
  }

  clickLogo(type): void {
    if (this.interfaceService.isTelesellerDomain) {
      this.senderService.toggleSenderChat();
    } else {
      this.setService(type);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get isDebug(): boolean {
    return location.hostname === 'localhost';
  }

  goToLeads() {
    this.router.navigate(['/leads']);
    this.interfaceService.setFullSize(this.renderer);
  }
}
